(() => {
  if (window.yrpPreciseSearchBound) return;
  window.yrpPreciseSearchBound = true;
  const isLegacyScoped = value => /^title:"(?:[^"\\]|\\.)+"(?: AND title:"(?:[^"\\]|\\.)+")*$/.test(value);
  const scopeQuery = value => {
    const clean = value.replaceAll('&quot;','"').replaceAll('&#34;','"').replaceAll('&amp;','&').trim();
    if (!clean || isLegacyScoped(clean)) return clean;
    const brands = ['Nike', 'Adidas', 'ASICS', 'Jordan', 'Converse', 'Onitsuka', 'New', 'Balance'];
    return clean.replace(/^"+|"+$/g,'').split(/\s+/).filter(Boolean).map(term => {
      const matches = term.length >= 3 ? brands.filter(brand => brand.toLowerCase().startsWith(term.toLowerCase())) : [];
      const word = matches.length === 1 ? matches[0] : term;
      return 'title:"' + word.replace(/\\/g,'\\\\').replace(/"/g,'\\"') + '"';
    }).join(' AND ');
  };
  const normaliseUrl = url => {
    const value = url.searchParams.get('q');
    if (!value || !value.trim()) return false;
    const scoped = scopeQuery(value);
    const changed = value !== scoped || url.searchParams.get('type') !== 'product' || url.searchParams.get('options[prefix]') !== 'last';
    url.searchParams.set('q',scoped);
    url.searchParams.set('type','product');
    url.searchParams.set('options[prefix]','last');
    return changed;
  };
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const url = new URL(form.action,location.href);
    if (!/\/search\/?$/.test(url.pathname) || !form.querySelector('[name="q"]')) return;
    url.search = '';
    for (const [key,value] of new FormData(form)) if (typeof value === 'string' && value !== '') url.searchParams.append(key,value);
    if (!url.searchParams.get('q')?.trim()) return;
    normaliseUrl(url);
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(url.toString());
  },true);
  document.addEventListener('click',event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href,location.href);
    if (url.origin !== location.origin || !/\/search\/?$/.test(url.pathname) || !normaliseUrl(url)) return;
    event.preventDefault();
    location.assign(url.toString());
  });
  const current = new URL(location.href);
  if (/\/search\/?$/.test(current.pathname) && normaliseUrl(current)) location.replace(current.toString());
})();
